module.exports = __webpack_public_path__ + "static/company-profile-b8b5f948cb27b30265594ca711e4bb6d.pdf";